import PropTypes from 'prop-types';
import React from 'react';
import {
  Modal, Button,
} from 'react-bootstrap';
import diff from 'object-diff';
import { findById } from '../../../core/utils';
import HotelRoomPrefsForm from './HotelRoomPrefsForm';

class HotelRoomPrefsModal extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmit(values) {
    const idx = this.props.tour.groups.findIndex(findById, values.group);
    if (idx === -1) {
      console.log('Can not find group... ', values.group);
      return;
    }
    const initialValues = this.props.tour.groups[idx].hotel_prefs;
    const changedValues = diff(initialValues, values);
    this.props.savePreferences(values.group, changedValues);
  }
  render() {
    const groups = this.props.tour.groups;

    const searchPrefs = groups.map(group =>
      <div key={group.id} className="col-sm-9">
        <h4 className="spacing">{group.name}</h4>
        <p>{group.members_count} members</p>
        <HotelRoomPrefsForm
          id={group.id}
          initialValues={group.hotel_prefs}
          onSubmit={this.handleSubmit}
        />
      </div>,
    );
    return (
      <div>
        <Modal bsSize="large" show={this.props.show} onHide={this.props.onClose}>
          <Modal.Header closeButton>
            <Modal.Title>Hotel Room Preferences</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="panel">
              <div className="row">
                <div className="col-sm-9">Please enter the number and type of rooms you need.</div>
                {searchPrefs}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer><Button bsStyle="info" onClick={this.props.onClose}>Close</Button></Modal.Footer>
        </Modal>
      </div>
    );
  }
}


HotelRoomPrefsModal.propTypes = {
  tour: PropTypes.object.isRequired,
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  savePreferences: PropTypes.func.isRequired,
};

export default HotelRoomPrefsModal;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelRoomPrefsModal.js